/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.39"
        height="17.81"
        viewBox="0 0 19.39 17.81"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M3.69 10.74H1.53A1.53 1.53 0 0 1 0 9.22V1.49A1.53 1.53 0 0 1 1.53-.04h2.16a1.52 1.52 0 0 1 1.52 1.53v7.69a1.52 1.52 0 0 1-1.52 1.56ZM1.53 9.49h2.16a.27.27 0 0 0 .27-.27V1.49a.27.27 0 0 0-.27-.28H1.53a.28.28 0 0 0-.28.28v7.69a.28.28 0 0 0 .28.31Zm5.87 6.45-1.49-2.51-1.13-1.94a4.35 4.35 0 0 1-.81-2.36V2.49A2.42 2.42 0 0 1 6.1.08h7.13a4.06 4.06 0 0 1 2.29 1.37v.07l.13.16.14.21.16.24.17.28.2.32.44.76.38.67.73 1.32.84 1.57.56 1.06.06.2c.3 2-.69 3.15-2.73 3.15h-4.75c-.67 0-.88.22-.78 1l.39 2.94c.1 1.16-.25 2-1.1 2.31a2.09 2.09 0 0 1-2.59-1.08Zm2.57.57c.19-.07.31-.34.25-1l-.36-2.76c-.24-1.59.43-2.58 1.86-2.61h5.06c1.09 0 1.47-.48 1.35-1.56v-.06l-1-1.88-.75-1.38-.64-1.14-.33-.57-.37-.61-.15-.25-.11-.2-.12-.17-.1-.13-.14-.15a2.77 2.77 0 0 0-1.24-.74H6.26c-.64.1-1 .47-1 1.23v6.63a3.21 3.21 0 0 0 .61 1.69L8.3 14.9l.61 1.05.06.11c.19.43.51.6 1 .43Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'FacebookDislikeIcon';

export default Icon;
